export function buildBatchUpdateBody({ customerIds, rebate, message, displayMode, filterContext }) {
  const body = { customerIds: customerIds }
  if (rebate && rebate.apply) body.rebatePercent = (rebate.value === undefined ? null : rebate.value)
  if (message && message.apply) body.rebateMessage = (message.value === undefined ? null : message.value)
  if (displayMode && displayMode.apply) body.msgDisplayMode = (displayMode.value === undefined ? null : displayMode.value)
  if (typeof filterContext === 'string' && filterContext.trim()) body.filterContext = filterContext
  return body
}
